import axios from "../utils/AxiosInstance";
import { ResponseMessage } from "../models/ResponseMessage";
import { Constants } from "../constants/constants";
import {
  Branch,
  CreateBranchRequest,
  UpdateBranchRequest,
} from "../models/BranchModels";

const API_BASE_URL = Constants.API_BASE_URL;

export async function getBranchesByOrganizationAsync(
  organizationId: string,
): Promise<ResponseMessage<Branch[]>> {
  const response = await axios.get(
    `${API_BASE_URL}/branches/organizations/${organizationId}`,
  );

  return ResponseMessage.fromJson(response.data);
}

export async function createBranchAsync(
  token: string,
  branch: CreateBranchRequest,
): Promise<ResponseMessage<Branch>> {
  const response = await axios.post(`${API_BASE_URL}/branches`, branch, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return ResponseMessage.fromJson(response.data);
}

export async function updateBranchAsync(
  token: string,
  id: string,
  branch: UpdateBranchRequest,
): Promise<ResponseMessage<Branch>> {
  const response = await axios.put(`${API_BASE_URL}/branches/${id}`, branch, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return ResponseMessage.fromJson(response.data);
}

export async function deleteBranchAsync(
  token: string,
  id: string,
): Promise<ResponseMessage<boolean>> {
  const response = await axios.delete(`${API_BASE_URL}/branches/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return ResponseMessage.fromJson(response.data);
}
